module.exports = {
    cognitoUserPool: {
        auth: 'https://welles1.auth.us-east-1.amazoncognito.com/login?response_type=code&client_id=3tcpkr59qru453hqgko3k1cd9k&redirect_uri=https://app.welles.sg/auth-page',
        auth_redirect: 'https://app.welles.sg/auth-page',
        auth_token: 'https://welles1.auth.us-east-1.amazoncognito.com/oauth2/token',
        auth_user: 'https://welles1.auth.us-east-1.amazoncognito.com/oauth2/userInfo'
    }
}